import React from 'react';
import { Row, Col, Button, Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import './User.css';

const User = (props) => {
    const {user} = props;
    if (!user || !user.merchantProfile) {
        return null;
    }
    const merchantName = user.merchantProfile.merchantName.length > 50 ? user.merchantProfile.merchantName.substring(0, 50) + "..." : user.merchantProfile.merchantName;
    return (
        <Row className='justify-content-between'>
            <Col sm={'auto'}>
                <Row>
                    <Col sm={12} className="text-right text-dark font-weight-bold">{merchantName}</Col>
                    <Col sm={12} className="text-right text-dark font-weight-bolder small">{user.name}</Col>
                    <Col sm={12} className="text-right text-dark small">Last Login: {user.lastLogin}</Col>
                </Row>
            </Col>
            <Col sm={'auto'} className="pl-2 pt-4">
                <Row>
                    <Col sm={6} className="p-0">
                        <Dropdown alignRight >
                            <Dropdown.Toggle as={Button} className="p-0 link no-arrow" size="lg" variant="link">
                                <FontAwesomeIcon icon={faCog} className="mr-2"/>
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item as={Link} to="/change-password">Change Password</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Col>
                    <Col sm={6} className="p-0">
                        <Button className="p-0 link" size="lg" variant="link" onClick={props.onLogOut}>
                            <FontAwesomeIcon icon={faSignOutAlt} className="mr-2"/>
                        </Button>
                    </Col>
                </Row>
            </Col>                
        </Row>
    );
}
export default User;